/**
 * useUnreadCount — shell adapter hook.
 *
 * Returns the current unread notification count from the global
 * NotificationProvider (driven by central-notifications SSE).
 *
 * Shape matches SuiteShellAdapter.hooks.useUnreadCount.
 */

import { useNotifications } from '../context/NotificationProvider';

export function useUnreadCount() {
  const { unreadCount, isInitialLoading, lastError } = useNotifications();
  return {
    count: unreadCount,
    isLoading: isInitialLoading,
    isError: Boolean(lastError),
  };
}
